import styled from "@emotion/styled";
import { DESKTOP } from "@/themes/device";
import {
  MobileBody1,
  MobileBody2,
  MobileCaption1,
  WebBody1,
  WebBody2,
} from "@/system/day/font/font";
import {
  grayScale,
  mBody2,
  mBody4,
  mHeader1,
  wBody2,
  wBody4,
  wHeader2,
  swc,
} from "@teamsparta/design-system";

export const Wrapper = styled.section`
  display: flex;
  position: relative;
  flex-direction: column;
  margin: 0 auto;
  width: 328px;
  ${DESKTOP} {
    width: initial;
  }
`;

export const Title = styled.h1`
  ${mHeader1};
  color: ${grayScale.gray100};
  margin: 0 0 50px;
  ${DESKTOP} {
    ${wHeader2};
    text-align: center;
  }
`;

export const Chip = styled.div`
  margin: 50px auto 0;
  position: relative;
  ${DESKTOP} {
    margin: 80px auto 0;
  }
`;

export const Cards = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  position: relative;
  ${DESKTOP} {
    flex-direction: row;
    margin: 0 auto;
  }
`;

export const Card = styled.div<{ big?: boolean }>`
  background-color: white;
  border-radius: 8px;
  padding: 24px;
  ${DESKTOP} {
    padding: 30px;
    width: 369px;
    height: fit-content;
    /* height: ${({ big }) => (big ? "396" : "232")}px; */
  }
`;

export const Schedule = styled.span`
  ${MobileBody1};
  color: #83b4ff !important;
  display: block;
  ${DESKTOP} {
    ${WebBody1};
  }
`;

export const Detail = styled.div`
  padding: 10px 14px;
  background-color: ${grayScale.gray0};
  border-radius: 8px;
  margin-top: 20px;
  ${mBody2};
  color: ${grayScale.gray90}!important;
  span {
    ${mBody4};
    color: ${grayScale.gray70} !important;
  }
  ${DESKTOP} {
    ${wBody2};
    span {
      ${wBody4};
    }
  }
`;

export const SubTitle = styled.div`
  display: flex;
  ${MobileBody1};
  color: ${grayScale.gray90} !important;
  padding-top: 20px;
  span {
    padding: 0 10px;
    color: ${grayScale.gray40};
    font-weight: 200;
  }
  p {
    ${MobileBody2};
    color: ${grayScale.gray90} !important;
  }
  ${DESKTOP} {
    ${WebBody1};
    p {
      ${WebBody2};
    }
  }
`;

export const Info = styled.p`
  ${mBody2};
  color: ${grayScale.gray80} !important;
  padding-top: 6px;
  ${DESKTOP} {
    ${wBody2};
  }
`;

export const Points = styled.div`
  padding-top: 20px;
  ${DESKTOP} {
    display: grid;
    gap: 20px;
  }
`;

export const Point = styled.div`
  display: flex;
  :nth-of-type(n + 2) {
    padding-top: 20px;
  }
  ${DESKTOP} {
    :nth-of-type(n + 2) {
      padding-top: 0;
    }
  }
`;

export const Number = styled.div`
  min-width: 20px;
  height: 20px;
  background: rgba(16, 102, 255, 0.1);
  border-radius: 83px;
  display: flex;
  align-items: center;
  justify-content: center;
  ${MobileCaption1};
  color: ${swc.blue} !important;
`;

export const Text = styled.div`
  padding-left: 10px;
  p:nth-of-type(1) {
    ${MobileBody1};
    color: ${grayScale.gray90} !important;
    ${DESKTOP} {
      ${WebBody1};
    }
  }
  p:nth-of-type(2) {
    ${MobileBody2};
    color: ${grayScale.gray80} !important;
    padding-top: 4px;
    ${DESKTOP} {
      ${WebBody2};
    }
  }
`;

export const TextDetail = styled.p`
  white-space: pre-line;
`;
